module.exports = __webpack_public_path__ + "static/media/awesome.d9eee02b.gif";